/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiComponentBlockCategoryFromJSON, ApiComponentBlockCategoryToJSON, } from './ApiComponentBlockCategory';
import { ApiComponentTypeFromJSON, ApiComponentTypeToJSON, } from './ApiComponentType';
import { ApiComponentUISourceFromJSON, ApiComponentUISourceToJSON, } from './ApiComponentUISource';
export function ApiCreateUpdateComponentPayloadFromJSON(json) {
    return ApiCreateUpdateComponentPayloadFromJSONTyped(json, false);
}
export function ApiCreateUpdateComponentPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aiCss': !exists(json, 'aiCss') ? undefined : json['aiCss'],
        'aiHtml': !exists(json, 'aiHtml') ? undefined : json['aiHtml'],
        'aiJs': !exists(json, 'aiJs') ? undefined : json['aiJs'],
        'category': !exists(json, 'category') ? undefined : ApiComponentBlockCategoryFromJSON(json['category']),
        'css': !exists(json, 'css') ? undefined : json['css'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'favicon': !exists(json, 'favicon') ? undefined : json['favicon'],
        'grapeJs': !exists(json, 'grapeJs') ? undefined : json['grapeJs'],
        'head': !exists(json, 'head') ? undefined : json['head'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'js': !exists(json, 'js') ? undefined : json['js'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'promptId': !exists(json, 'promptId') ? undefined : json['promptId'],
        'seoDescrition': !exists(json, 'seoDescrition') ? undefined : json['seoDescrition'],
        'seoTitle': !exists(json, 'seoTitle') ? undefined : json['seoTitle'],
        'theme': !exists(json, 'theme') ? undefined : json['theme'],
        'type': !exists(json, 'type') ? undefined : ApiComponentTypeFromJSON(json['type']),
        'uiSource': !exists(json, 'uiSource') ? undefined : ApiComponentUISourceFromJSON(json['uiSource']),
    };
}
export function ApiCreateUpdateComponentPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aiCss': value.aiCss,
        'aiHtml': value.aiHtml,
        'aiJs': value.aiJs,
        'category': ApiComponentBlockCategoryToJSON(value.category),
        'css': value.css,
        'description': value.description,
        'favicon': value.favicon,
        'grapeJs': value.grapeJs,
        'head': value.head,
        'html': value.html,
        'js': value.js,
        'name': value.name,
        'promptId': value.promptId,
        'seoDescrition': value.seoDescrition,
        'seoTitle': value.seoTitle,
        'theme': value.theme,
        'type': ApiComponentTypeToJSON(value.type),
        'uiSource': ApiComponentUISourceToJSON(value.uiSource),
    };
}
